/* import __COLOCATED_TEMPLATE__ from './series.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();